<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Gestion des structures">
        <v-row>
          <v-col cols="12" md="4">
            <router-link
              :to="{
                name: 'form-structure',
              }"
              tag="v-btn"
            >
              <v-icon title="Ajouter une structure">mdi-plus</v-icon>
              Ajouter une structure</router-link
            >
          </v-col>
        </v-row>
        <v-row v-if="listeStructures.length > 0">
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <v-data-table
              :headers="headers"
              :items="listeStructures"
              :items-per-page="10"
              :search="search"
              item-key="id"
              disable-sort
              class="elevation-1"
            >
              <template v-slot:[`item.libelle`]="{ item }">
                <span v-if="!item.hasReferents" class="warning--text">{{
                  item.libelle
                }}</span>
                <span v-else>{{ item.libelle }}</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'form-structure',
                    params: {
                      idStructure: item.id,
                    },
                  }"
                >
                  <v-icon
                    class="mr-2"
                    title="Éditer la structure"
                    color="primary"
                    >mdi-pencil</v-icon
                  ></router-link
                >

                <ActionConfirmation
                  icone="mdi-delete"
                  title="Supprimer la structure"
                  @ok="deleteStructure(item.id)"
                ></ActionConfirmation>
              </template>
              <template v-slot:top>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Recherche"
                    single-line
                    hide-details
                    class="mx-5"
                  ></v-text-field>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiStructureRepository from "@/repositories/ApiStructureRepository";
import ActionConfirmation from "@/components/ActionConfirmation";

export default {
  name: "ListeStructures",
  components: { BaseBlock, ActionConfirmation },

  data() {
    return {
      headers: [
        {
          text: "Libellé",
          align: "left",
          value: "libelle",
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          width: "20%",
        },
      ],
      listeStructures: [],
      search: "",
      loading: false,
    };
  },
  async created() {
    await this.getListeStructures();
  },
  methods: {
    async getListeStructures() {
      try {
        const listeStructures =
          await ApiStructureRepository.getListeStructures();
        this.listeStructures = listeStructures;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    async deleteStructure(id) {
      this.loading = true;
      try {
        await ApiStructureRepository.deleteStructure(id);
        await this.getListeStructures();
        this.$toast.success("Structure supprimée");
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
